import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { GetMsgUsers } from "../../apis/message/get_msg_users";
import HeaderMenu from "../sidebar/headermenu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MessageBox from "./message_box";
import { SearchUserApi } from "../../apis/user/search_user_api";
import PlaceHolder from "../../utils/placeholder";

export default function MessageUsers() {
    const navigate = useNavigate();
    const [udata, setUdata] = useState([]);
    const [getApi, setGetApi] = useState(API_STATUS);
    const [loginId, setLoginId] = useState("");
    const [selUser, setSelUser] = useState("");

    const location = useLocation();

    const [searchData, setSearchData] = useState([]);
    const [searchApi, setSearchApi] = useState(API_STATUS);
    const [noData, setNodata] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const [loginSub, setLoginSub] = useState(false);

    // State to toggle the mobile sidebar drawer
    const [showSidebar, setShowSidebar] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("LIVENESS") === '0') {
            navigate("/video_kyc_pending");
        }
    }, [navigate]);

    useEffect(() => {
        if (selUser == "") {
            setShowSidebar(true);
        }
    }, [selUser]);

    useEffect(() => {
        setSearchData([]);
        if (!searchApi.isLoader && !searchApi.isError && searchApi.data != null) {
            if (searchApi.data.status === 1) {
                setSearchData(searchApi.data.data);
            } else {
                setNodata(true);
            }
        }
    }, [searchApi]);

    const doSearch = () => {
        if (searchKey !== "") {
            setSearchData([]);
            setNodata(false);
            SearchUserApi({ 'search_key': searchKey }, setSearchApi);
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);
            const utype = sessionStorage.getItem('USER_TYPE');
            GetMsgUsers(setGetApi);

            if (location.state !== null) {
                const userData = location.state.userData;
                setSelUser({
                    'user_pic': userData.userPic,
                    'uid': userData.userId,
                    'first_name': userData.firstName,
                    'last_name': userData.lastName,
                    'username': userData.username
                });
            }

            const loginData = sessionStorage.getItem('LOGIN_DATA');
            const logingUser = JSON.parse(loginData);

            if (utype === '0') {
                if (logingUser['subPayStatus'] !== null && logingUser['subPayStatus'] === 1) {
                    setLoginSub(true);
                }
            }

            if (utype === '1') {
                setLoginSub(true);
            }
        }
    }, [location.state, navigate]);

    useEffect(() => {
        if (!getApi.isError && !getApi.isLoader && getApi.data != null) {
            let res = getApi.data;
            if (res['status'] === 1) {
                setUdata(res['data']);
            }
        }
    }, [getApi]);

    useEffect(() => {
        const interval = setInterval(() => {
            GetMsgUsers(setGetApi);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div id="wrapper">
            <HeaderMenu />
            <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
                <div className="2xl:max-w-6xl mx-auto h-screen relative shadow-lg overflow-hidden border1 max-md:pt-14">
                    <div className="flex bg-white dark:bg-dark2">

                        {/* Dark backdrop overlay on mobile when sidebar drawer is open */}
                        {showSidebar && (
                            <div
                                className="fixed inset-0 bg-black/50 z-40 md:hidden"
                                onClick={() => setShowSidebar(false)}
                            />
                        )}

                        <div className="md:w-[360px] relative border-r dark:border-slate-700">
                            {/* Slide-over Drawer with dynamic Tailwind transform class */}
                            <div
                                id="side-chat"
                                className={`top-0 left-0 max-md:fixed max-md:w-5/6 h-screen bg-white z-50 max-md:shadow dark:bg-dark2 transition-transform duration-300 ease-in-out ${showSidebar ? "max-md:translate-x-0" : "max-md:-translate-x-full"
                                    }`}
                            >
                                <div className="p-4 border-b dark:border-slate-700 flex items-center justify-between">
                                    <h2 className="text-2xl font-bold text-black ml-1 dark:text-white"> Chats </h2>
                                    {/* Close X Button for mobile view */}
                                    <button
                                        onClick={() => setShowSidebar(false)}
                                        className="md:hidden text-gray-500 hover:text-black dark:text-white p-1"
                                    >
                                        <i className="fa fa-times text-xl" aria-hidden="true"></i>
                                    </button>
                                </div>

                                {loginSub && (
                                    <div className="relative px-4 mt-4">
                                        <div onClick={doSearch} className="absolute right-7 bottom-0 top-0 flex p-2 items-center cursor-pointer">
                                            <i className="fa fa-search" aria-hidden="true"></i>
                                        </div>
                                        <input
                                            type="text"
                                            onChange={(v) => setSearchKey(v.target.value)}
                                            placeholder="Search"
                                            value={searchKey}
                                            className="w-full !pr-10 !py-2 !rounded-lg"
                                        />
                                    </div>
                                )}

                                {noData && <div className="p-3">No result found for {searchKey}</div>}
                                {searchApi.isLoader && <PlaceHolder />}

                                {!loginSub && (
                                    <div className="ml-auto text-blue-400 dark:text-white p-5 text-[15px]">
                                        <Link to={'/profile/' + loginId}>Subscribe as artist to start chat.</Link>
                                    </div>
                                )}

                                {/* Search Results List */}
                                {searchData.length > 0 && loginSub && (
                                    <div className="p-2 space-y-2 dark:text-white overflow-y-auto h-[calc(100vh-127px)] pb-[150px]">
                                        <div className="flex items-center justify-between py-2.5 px-3 font-semibold">
                                            <h4>Search Result</h4>
                                            <button
                                                onClick={() => {
                                                    setSearchData([]);
                                                    setSearchKey('');
                                                }}
                                                type="button"
                                                className="text-blue-500 text-sm"
                                            >
                                                Clear all
                                            </button>
                                        </div>
                                        {searchData.map((item, i) => (
                                            <div key={i}>
                                                {item.userId !== loginId && ((item['subId'] != null && item['subPayStatus'] === 1) || item['userType'] === 1) && (
                                                    <Link
                                                        onClick={() => {
                                                            setSelUser({ 'user_pic': item.userPic, 'uid': item.userId, 'first_name': item.firstName, 'last_name': item.lastName, 'username': item.username });
                                                            setShowSidebar(false); // Close sidebar on mobile
                                                        }}
                                                        className="relative flex items-center gap-3 p-2 duration-200 rounded-xl hover:bg-secondery"
                                                    >
                                                        <img src={item.userPic} alt="" className="bg-gray-200 rounded-full w-10 h-10" />
                                                        <div className="flex-1 min-w-0">
                                                            <div className="flex flex-row items-center">
                                                                <h4 className="font-medium text-sm text-black dark:text-white">{item.firstName + ' ' + item.lastName}</h4>
                                                                {item['subId'] != null && item['subPayStatus'] === 1 && (
                                                                    <div className="text-[#17ce85] text-sm pl-1"><i className="fa fa-check-circle" aria-hidden="true"></i></div>
                                                                )}
                                                            </div>
                                                            <div className="text-xs text-gray-500 font-normal mt-0.5 dark:text-white-80">{item.username}</div>
                                                        </div>
                                                    </Link>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Main Recent Users List */}
                                {udata.length > 0 && searchData.length < 1 && loginSub && (
                                    <div className="space-y-2 p-2 overflow-y-auto h-[calc(100vh-127px)]">
                                        {udata.map((item, i) => (
                                            <Link
                                                key={i}
                                                onClick={() => {
                                                    setSelUser(item);
                                                    setShowSidebar(false); // Close sidebar on mobile
                                                }}
                                                className="relative flex items-center gap-4 p-2 duration-200 rounded-xl hover:bg-secondery"
                                            >
                                                <div className="relative w-14 h-14 shrink-0">
                                                    <img src={item.user_pic} alt="" className="object-cover w-full h-full rounded-full" />
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center gap-2 mb-1.5">
                                                        <div className="mr-auto text-sm text-black dark:text-white font-medium">{item.first_name + ' ' + item.last_name}</div>
                                                        {item.unread > 0 && (
                                                            <div className="text-xs font-light text-white dark:text-white/70 bg-red-600 px-1.5 py-0.5 rounded-full">{item.unread}</div>
                                                        )}
                                                    </div>
                                                    <div className="flex items-center gap-2 mb-1.5">
                                                        <div className="font-medium text-sm mr-auto">{item.username}</div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* Selected Chat Box View */}
                        {selUser !== "" && loginSub && (
                            <MessageBox
                                udata={selUser}
                                onOpenSidebar={() => setShowSidebar(true)}
                            />
                        )}

                        {/* Empty State View */}
                        {selUser === "" && (
                            <div className="flex-1">
                                <div className="w-full p-5 py-10 overflow-y-auto md:h-[calc(100vh-137px)] h-[calc(100vh-250px)] flex flex-col items-center justify-center">
                                    <button
                                        onClick={() => setShowSidebar(true)}
                                        className="md:hidden mb-6 px-4 py-2 bg-blue-500 text-white rounded-lg text-sm font-medium shadow"
                                    >
                                        <i className="fa fa-users mr-2" aria-hidden="true"></i> View User List
                                    </button>
                                    <div className="flex items-center justify-center text-6xl text-gray-800 border border-gray-800 rounded-full h-24 w-24">
                                        <i className="fa fa-comments-o" aria-hidden="true"></i>
                                    </div>
                                    <div className="text-lg mt-2 font-medium">Your Message</div>
                                    <div className="text-sm mt-1 text-gray-500">Search / select user to start chat</div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </main>
        </div>
    );
}